<template>
  <div class="home">
    <div class="banner__wrapper">
      <img :src="pageData.banner"/>
      <img :class="['logo', { 'in': logoAnimate }]" :src="pageData.logo"/>
    </div>
    <div class="post__list__wrapper">
      <ul class="post__list">
        <li
          v-for="item in posts"
          :key="item.id"
          class="post__item"
          :id="`post-${item.id}`">
          <TestvPostItem
            class="comp__TestvPostItem"
            :post="item"
          />
        </li>
        <div v-show="loaded" class="loading__wrapper">
          <TestvLoading
            class="comp__TestvLoading"
            :loading="loading"
            :loadEnd="loadEnd"
            :noDataAvailable="!posts.length"
          />
        </div>
      </ul>
    </div>

    <footer>
      <TestvFooter/>
    </footer>
  </div>
</template>

<script>
import TestvPostItem from '@/components/TestvPostItem/index.vue'
import TestvFooter from '@/components/TestvFooter/index.vue'
import TestvLoading from '@/components/TestvLoading/index.vue'
import postListMixin from '@/mixins/post-list.js'

export default {
  name: 'Home',

  mixins: [postListMixin],

  components: {
    TestvPostItem,
    TestvFooter,
    TestvLoading
  },

  data () {
    return {
      logoAnimate: true
    }
  },

  deactivated () {
    this.logoAnimate = false
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.home {
  min-height: 100vh;
  @media (min-width: $screen-md) {
    padding-bottom: 48px;
  }
}
.banner__wrapper {
  position: relative;
  height: 204px;
  @media (min-width: $screen-md) {
    height: 373px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .logo {
    width: auto;
    height: 164px;
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    filter: drop-shadow(0px 11px 14px rgba(0, 0, 0, 0.25));
    transform-origin: left top;
    &.in {
      animation: logo__in 0.8s cubic-bezier(.33,.18,.44,1.03) forwards;
    }
    @media (min-width: $screen-md) {
      height: 293px;
    }
    @media (min-width: $screen-default) {
      height: 301px;
    }
  }
}

.post__list__wrapper,
footer {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px 0 16px;
  @media (min-width: $screen-md) {
    max-width: 780px;
    padding: 0 105px 0px 32px;
  }
}

.post__list {
  .post__item {
    margin-bottom: 40px;
    margin-top: 40px;
    &:nth-last-child(2) {
      margin-bottom: 0px;
      >>> .testv__post__item__right::after {
        display: none;
      }
    }
    @media (min-width: $screen-md) {
      margin-bottom: 56px;
      margin-top: 56px;
    }
  }
}

.loading__wrapper {
  padding-left: 52px
  margin-right: 0px;
  margin-bottom: 12px;
  @media (min-width: $screen-md) {
    padding-left: 131px
  }
  @media (min-width: $screen-lg) {
    max-width: 600px;
    margin-left: auto;
  }
}

.post__item {
  opacity: 0;
  transform: translateY(50px);
  transition: all 1s ease;
  &.slide {
    opacity: 1;
    transform: translateY(0px);
  }
}

@keyframes logo__in {
  0% {
    transform: scale(0) rotate(-8deg) translate(-50%, -50%);
  }
  100% {
    transform: scale(1) rotate(0) translate(-50%, -50%);
  }
}
</style>
